import * as yup from 'yup';
import { FIELD } from './types';

export const validationSchema = () =>
  yup.object().shape({
    [FIELD.PASSWORD]: yup
      .string()
      .nullable()
      .min(12, 'Please use at least 12 characters')
      .matches(RegExp('(.*[a-z].*)'), 'Please use at least 1 lowercase character')
      .matches(RegExp('(.*[A-Z].*)'), 'Please use at least 1 uppercase character')
      .matches(RegExp('(.*\\d.*)'), 'Please use at least 1 numeric character')
      .matches(/[-!$%^&*()_+|~=`{}[\]:\\/;<>?,.@#]/, 'Please use at least 1 special character')
      .required('Password is mandatory.'),

    [FIELD.CONFIRM_PASSWORD]: yup
      .string()
      .nullable()
      .oneOf([yup.ref(FIELD.PASSWORD), null], 'Your passwords do not match')
      .required('Confirmation of password is mandatory.'),
  });
